<template>
	<v-dialog
		v-model="confirmar"
		:width="$vuetify.breakpoint.lgAndUp? '33%':'auto'"
		v-bind="$attrs"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn 
				color="info"
				dark
				v-bind="attrs"
				v-on="on"
				:disabled="!contribuyente"
				:loading=loading
			>
				<v-icon left>
					sync
				</v-icon>
				Descargar CAF
			</v-btn>
		</template>
		<v-card tile>
			<v-card-title class="text-center">
				<v-spacer/>
				<v-icon large color="primary">sync</v-icon>
				<v-spacer/>
		</v-card-title>
			<v-card-title class="text-center">
				<v-spacer/>
				<v-spacer/>
			</v-card-title>
			<v-card-text>
				Confirme para descargar CAF para el contribuyente {{rut}}
				<v-list class="transparent" dense>
					<v-list-item
						v-for="item in items"
						:key="`val_actua_${item.value}`"
					>
						<v-list-item-subtitle
							v-text=item.title
						/>
						<v-tooltip top color=primary>
							<template v-slot:activator="{ on, attrs }">
								<v-list-item-title
									class="text-center"
									v-text="item.value"
									v-on="on"
								/>
							</template>
							<span>{{item.value}}</span>
						</v-tooltip>
					</v-list-item>
				</v-list>
			</v-card-text>
			<v-divider/>
			<v-card-actions>
				<v-btn
					color="error"
					text
					@click="confirmar = false"
				>
					Cancelar
				</v-btn>
				<v-spacer/>
				<v-btn
					color="success"
					tile
					@click="descargarCaf"
				>
					Descargar CAF
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>

import axios from 'axios';
import {getEnvVar} from '@/library/utils/env-vars';

export default {
	props:{
		contribuyente: Object,
	},
	computed:{
		rut(){

			if( !this.contribuyente ){

				return null;
			}else{
				let out = `${this.contribuyente.rut}-${this.contribuyente.dv}`
				return out;
			}
		},
		items(){
			return [
				{
					title: 'RUT',
					value: this.rut
				},
				{
					title: 'Razón Social',
					value: this.contribuyente.razon_social
				}
			]
		}
	},
	data() {
		return {
			loading: false,
			confirmar: false,
		}
	},
	methods: {
		async descargarCaf(){

			let vm = this;
			try{

				vm.loading = true;
				vm.confirmar = false;

				const url = getEnvVar('DESCARGAR_CAF_URL');

				const rutCAF = vm.rut;

				let payload = { dte: 39, rut:rutCAF };

				var response = await axios.post('https://xxjvp1u9cj.execute-api.us-east-1.amazonaws.com/v2'+url, payload);
				vm.showMsg('success','Se ha descargado CAFs para el rut '+this.rut);
			}catch(err){
				vm.showMsg('error','Ha ocurrido un error: '+err);
			}finally{
				vm.loading = false;
				vm.confirmar = false;
			}
		},
		showMsg(type, msg){
			this.$emit('alert', {tipo:type, mensaje:msg});
		}
	}
}
</script>

<style>

</style>